import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-teal-50 to-white p-6">
      <div className="max-w-3xl mx-auto">
        <Button
          variant="ghost"
          onClick={() => window.close()}
          className="mb-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Close
        </Button>

        <Card>
          <CardHeader>
            <CardTitle className="text-2xl">Terms of Service</CardTitle>
            <p className="text-sm text-muted-foreground">Last updated: December 2025</p>
          </CardHeader>
          <CardContent className="prose prose-sm max-w-none space-y-6">
            <section>
              <h3 className="text-lg font-semibold">1. Acceptance of Terms</h3>
              <p className="text-muted-foreground">
                By accessing and using PayMig, you accept and agree to be bound by the terms
                and conditions of this agreement. If you do not agree to these terms, please
                do not use our service.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">2. Description of Service</h3>
              <p className="text-muted-foreground">
                PayMig is a family payment management platform that enables parents to
                approve and process payment requests from their children through the Swish
                payment system. The service includes:
              </p>
              <ul className="list-disc list-inside text-muted-foreground ml-4 space-y-1">
                <li>Parent account management and dashboard</li>
                <li>MobPay companion app for children</li>
                <li>WatchPay integration for smartwatches</li>
                <li>Payment request and approval workflow</li>
                <li>Transaction history and analytics</li>
              </ul>
            </section>

            <section>
              <h3 className="text-lg font-semibold">3. User Accounts</h3>
              <p className="text-muted-foreground">
                You are responsible for maintaining the confidentiality of your account
                credentials and for all activities that occur under your account. You agree
                to notify us immediately of any unauthorized use of your account.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">4. Payment Processing</h3>
              <p className="text-muted-foreground">
                PayMig facilitates payment requests between family members using the Swish
                payment system. We do not process payments directly; all transactions are
                handled through Swish. You are responsible for ensuring sufficient funds
                and complying with Swish's terms of service.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">5. Subscription Plans</h3>
              <p className="text-muted-foreground">
                Some features of PayMig require a paid subscription. Subscription fees are
                billed according to your chosen plan (monthly or annual). You may cancel
                your subscription at any time, but refunds are not provided for partial
                billing periods.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">6. User Conduct</h3>
              <p className="text-muted-foreground">
                You agree not to use PayMig for any unlawful purpose or in any way that
                could damage, disable, or impair the service. You may not attempt to gain
                unauthorized access to any part of the service or its related systems.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">7. Limitation of Liability</h3>
              <p className="text-muted-foreground">
                PayMig is provided "as is" without warranties of any kind. We shall not
                be liable for any indirect, incidental, special, or consequential damages
                arising from your use of the service.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">8. Changes to Terms</h3>
              <p className="text-muted-foreground">
                We reserve the right to modify these terms at any time. We will notify
                users of significant changes through the app or via email. Continued use
                of the service after changes constitutes acceptance of the new terms.
              </p>
            </section>

            <section>
              <h3 className="text-lg font-semibold">9. Contact Information</h3>
              <p className="text-muted-foreground">
                If you have any questions about these Terms of Service, please contact us
                at support@paymig.com.
              </p>
            </section>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
